const ChannelError = {
  FEATURE_DISABLED: 'FEATURE_DISABLED',
  CHANNEL_NOT_FOUND: 'CHANNEL_NOT_FOUND',
};

export {
  ChannelError,
};
